import {modalController} from "@ionic/vue";
import FeedNewPostPage from "@/views/feed/FeedNewPostPage.vue";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import {UserInterface} from "@/interfaces/UserInterface";
import FeedNewVideoPage from "@/views/feed/FeedNewVideoPage.vue";

export function useFeed() {

    const post = async (authUser: UserInterface) => {
        const modal = await modalController.create({
            component: FeedNewPostPage,
            mode: 'ios',
            componentProps: {
                authUser
            },
            presentingElement: document.getElementById('tabs') as HTMLElement,
        })
        await modal.present()
    }

    const video = async (authUser: UserInterface) => {
        const modal = await modalController.create({
            component: FeedNewVideoPage,
            mode: 'ios',
            componentProps: {
                authUser
            },
            presentingElement: document.getElementById('tabs') as HTMLElement,
        })
        await modal.present()
    }

    return {
        post,
        video
    }

}